/**
 * Subcategory Repository
 */

import { apiClient } from '../../client'
import type { PaginatedResponse } from '../role.repository'

export interface Subcategory {
    id: number
    tenant_id: number

    en_name: string
    ar_name?: string | null
    status: number
    created_by?: number | null
    updated_by?: number | null
    created_at: Date
    updated_at: Date
    ref_code?: string

}

export interface CreateSubcategoryRequest {
    tenant_id: number

    en_name: string
    ar_name?: string
    status?: number
    ref_code?: string

}

export interface UpdateSubcategoryRequest {
    tenant_id?: number

    en_name?: string
    ar_name?: string
    status?: number
    ref_code?: string

}

class SubcategoryRepository {
    async getAll(page: number = 1, limit: number = 25, filters?: any): Promise<PaginatedResponse<Subcategory>> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        })

        if (filters) {
            if (filters.search) params.append('search', filters.search)
            if (filters.status) params.append('status', filters.status)

            if (filters.subcategory_id) params.append('subcategory_id', filters.subcategory_id)
        }

        return apiClient.get<PaginatedResponse<Subcategory>>(`/subcategories?${params.toString()}`)
    }

    async getById(id: number): Promise<Subcategory> {
        return apiClient.get<Subcategory>(`/subcategories/${id}`)
    }

    async create(data: CreateSubcategoryRequest): Promise<Subcategory> {
        return apiClient.post<Subcategory>('/subcategories', data)
    }

    async update(id: number, data: UpdateSubcategoryRequest): Promise<Subcategory> {
        return apiClient.put<Subcategory>(`/subcategories/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/subcategories/${id}`)
    }

    async exportToExcel(filters?: any): Promise<Blob> {
        const params = new URLSearchParams()
        if (filters?.search) params.append('search', filters.search)
        if (filters?.status) params.append('status', filters.status)

        if (filters?.category_id) params.append('category_id', filters.category_id.toString())
        if (filters?.subcategory_id) params.append('subcategory_id', filters.subcategory_id.toString())

        const baseUrl = `/subcategories/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }
}

export const subcategoryRepository = new SubcategoryRepository()

